import { formatToCPF } from 'brazilian-values'
import moment from 'moment'
import React from 'react'

import { APPLICATION_RESULT_MESSAGES, APPLICATION_STATUS_MESSAGES } from 'utils/constants/kypStatuses'
import styles from './styles'

function ApplicantInfo(props) {
  const { applicantData, applicationStatus, applicationResult } = props
  const classes = styles()
  return applicantData ? (
    <div className={classes.root}>
      <p>
        <span>Nome: </span>
        {applicantData?.name || 'N/A'}
      </p>
      <p>
        <span>CPF: </span>
        {applicantData?.cpf
          ? formatToCPF(applicantData?.cpf)
          : 'N/A'}
      </p>
      <p>
        <span>Data de nascimento: </span>
        {moment(applicantData?.birth_date).format(
          'DD/MM/YYYY',
        )}
      </p>
      <p>
        <span>Filiação: </span>
        {applicantData?.affiliation || 'N/A'}
      </p>
      {applicationStatus && <p>
        <span>Status da aplicação: </span>
        {APPLICATION_STATUS_MESSAGES[applicationStatus]}
      </p>}
      {applicationResult && <p>
        <span>Resultado da aplicação: </span>
        <span style={{ color: applicationResult === 'REPROVED' ? 'red' : 'green' }}>{APPLICATION_RESULT_MESSAGES[applicationResult]}</span>
      </p>}
    </div>
  ) : null
}

export default ApplicantInfo
